import {useCallback, useEffect} from 'react';
import View from './view';
import {useNavigation} from '@react-navigation/native';
import {Screens} from '../../shared/routing';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../redux';
import React from 'react';
import {faqSelector} from '../../redux/selectors/resources';
import {getFaq} from '../../redux/actions/resources';
import {profileHolderUscTypeSelector} from '../../redux/selectors/profile';
import {UscType} from '../../shared/models/profile/uscType';

export const SupportServiceScreen = () => {
  const nav = useNavigation();
  const dispatch = useAppDispatch();
  const faqQuestions = useSelector(faqSelector());
  const cardUscType = useSelector(profileHolderUscTypeSelector());

  useEffect(() => {
    if (!faqQuestions) {
      dispatch(getFaq());
    }
  }, [faqQuestions]);

  const handleTopicsButtonPress = useCallback(() => {
    nav.navigate(Screens.SupportServiceTopics);
  }, [nav]);

  const handleAssistantButtonPress = useCallback(() => {
    nav.navigate(Screens.SupportServiceChatbot);
  }, [nav]);

  return React.createElement(View, {
    questions: faqQuestions,
    onPressTopicsButton: handleTopicsButtonPress,
    onPressAssistantButton: handleAssistantButtonPress,
    isFinancial: cardUscType === UscType.Financial,
  });
};
